import { useController, useFormContext } from 'react-hook-form';
import { FormFieldProps, OptionProps } from '..';
import styles from './FormNumberedCheckboxesGroup.module.scss';
import { defaultValidationMessage } from '../config/validators/validators';
import { hasValue } from '@r-and-a-shared-ui/utils';
import { RichTextParser } from '@r-and-a-shared-ui/common-ui';

export function FormNumberedCheckboxesGroup(props: FormFieldProps) {
  const { name, label, isDisabled, validationMessage, options } = props;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { field } = useController({
    name,
    control,
    defaultValue: [],
  });
  const selectedValues: (string | undefined)[] = Array.isArray(field.value)
    ? field.value
    : [];

  const toggle =
    (val?: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const nextVal = event.target.checked
        ? [...selectedValues, val]
        : selectedValues.filter(selectedValue => selectedValue !== val);

      field.onChange(nextVal);
    };

  return (
    <div
      id={name}
      className={`${styles['form-element']}  ${
        errors?.[name] ? styles['form-element__has-error'] : ''
      }`}
    >
      {hasValue(label) && (
        <label className={styles['form-element__label']} htmlFor={name}>
          {label}
        </label>
      )}
      <div
        className={`${
          (options?.length ? options?.length > 1 : false)
            ? styles['form-element__checkbox-multiple']
            : styles['form-element__checkbox-single']
        }`}
      >
        {options?.map((option, index) => (
          <div
            key={`${name}_${option.value}`}
            className={`${styles['form-element__checkbox']} ${
              isDisabled || option.isDisabled
                ? styles['form-element__checkbox--is-disabled']
                : ''
            }`}
          >
            <span className={styles['form-element__no']}>{index + 1}.</span>
            <label>
              <RichTextParser richText={option.label} />
              <input
                type="checkbox"
                name={field.name}
                ref={field.ref}
                onBlur={field.onBlur}
                value={option.value}
                checked={selectedValues.includes(option.value)}
                onChange={toggle(option.value)}
                disabled={isDisabled || option.isDisabled}
              />
              <span className={styles['form-element__checkmark']}></span>
            </label>
          </div>
        ))}
      </div>
      {errors?.[name] ? (
        <small className={styles['form-element__hint']}>
          {validationMessage || defaultValidationMessage}
        </small>
      ) : null}
    </div>
  );
}

export default FormNumberedCheckboxesGroup;
